import { useClientStore } from '@/features/Clients';
import { useGlobalStore } from '@/features/Global/store';
import { useTariffStore } from '@/features/Tariffs/store';

export const tariffsResultMatchesSearch = (): boolean =>
  useTariffStore().requests.lastHashCode ===
  useGlobalStore().getTariffSearchHash();

const isCompanyClientBlocked = (): boolean =>
  useClientStore().vnIsBlockedCompany;

const tariffsSelected = (): boolean =>
  useTariffStore().selectedTariffs.length > 0;

const hasTariffSearchResult = (): boolean =>
  Object.keys(useTariffStore().tariffChunks).length > 0;

interface UseStepValidators {
  tariffsResultMatchesSearch: () => boolean;
  tariffsSelected: () => boolean;
  hasTariffSearchResult: () => boolean;
  isCompanyClientBlocked: () => boolean;
}

export const useStepValidators = (): UseStepValidators => ({
  tariffsResultMatchesSearch,
  tariffsSelected,
  hasTariffSearchResult,
  isCompanyClientBlocked,
});
